var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("vue-easymde", {
        ref: "markdownEditor",
        attrs: { highlight: true, value: _vm.value },
        on: {
          "update:modelValue": _vm.changeValue,
          blur: function ($event) {
            return _vm.$emit("blur")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }